import { useCallback } from 'react';
import { NavigateOptions, useLocation, useNavigate } from 'react-router-dom';
import { useRedux } from 'hooks';
import { getModuleListPath, getWorkspaceTabKey } from 'layouts/WorkspaceTabs/tabTitle';
import { closeWorkspaceTab } from 'redux/workspaceTabs/actions';
import { WorkspaceTab } from 'redux/workspaceTabs/types';

const useWorkspaceNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dispatch, appSelector } = useRedux();
  const tabs = appSelector((state) => state.WorkspaceTabs.tabs as WorkspaceTab[]);

  const navigateAndCloseCurrentTab = useCallback(
    (target: string, options?: NavigateOptions) => {
      const currentTabKey = getWorkspaceTabKey(location.pathname, location.search);
      navigate(target, options);
      dispatch(closeWorkspaceTab(currentTabKey));
    },
    [dispatch, location.pathname, location.search, navigate]
  );

  const navigateToModuleListAndCloseCurrentTab = useCallback(
    (listPath?: string) => {
      const target = listPath ?? getModuleListPath(location.pathname);
      if (!target) {
        return;
      }

      const listKey = target.replace(/\/+$/, '') || '/';
      const existing = tabs.find((tab) => (tab.pathname.replace(/\/+$/, '') || '/') === listKey);
      const destination = existing ? `${existing.pathname}${existing.search || ''}` : listKey;

      navigateAndCloseCurrentTab(destination);
    },
    [location.pathname, navigateAndCloseCurrentTab, tabs]
  );

  return {
    navigateAndCloseCurrentTab,
    navigateToModuleListAndCloseCurrentTab,
  };
};

export default useWorkspaceNavigate;
